import { render, staticRenderFns } from "./LabelSetSamplesThumbnailView.vue?vue&type=template&id=01a3c801&scoped=true&"
import script from "./LabelSetSamplesThumbnailView.vue?vue&type=script&lang=js&"
export * from "./LabelSetSamplesThumbnailView.vue?vue&type=script&lang=js&"
import style0 from "./LabelSetSamplesThumbnailView.vue?vue&type=style&index=0&id=01a3c801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3c801",
  null
  
)

export default component.exports